// // import React, { useState } from "react";
// // import {
// //     Box,
// //     Typography,
// //     Avatar,
// //     Paper,
// //     IconButton,
// //     Divider,
// // } from "@mui/material";
// // import EditIcon from "@mui/icons-material/Edit";
// // import EditRequest from "./EditRequest";
// // import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// // const ProfileSetting = () => {
// //     const [openDialog, setOpenDialog] = useState(false);
// //     const [requestText, setRequestText] = useState("");
// //     const [showInfoBox, setShowInfoBox] = useState(false);
// //     const info = {
// //         firstName: "Amit",
// //         lastName: "Singh",
// //         mobile: "9864328749",
// //         email: "aman@company.com",
// //         team: "TFR",
// //         access: "Dashboard, Report,",
// //         owner: "Alice Smith",
// //     };
// //     const handleSubmit = (request: string) => {
// //         console.log("Request submitted:", request);
// //         setOpenDialog(false);
// //         setShowInfoBox(true);
// //         // Add API call here if needed
// //     };
// //     return (

// //         <><Box sx={{ background: "#fff", borderBottom: "1px solid #7f7d7d70 !important" }}>
// //             <Box sx={{ p: 4 }}>
// //                 <Typography variant="body2" sx={{ mb: 1 }}>
// //                     <span style={{ color: "#777" }}>Profile /</span>{" "}
// //                     <span style={{ color: "#8E020F", fontWeight: 500 }}>Profile Setting</span>
// //                 </Typography>
// //                 <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
// //                     Profile Setting
// //                 </Typography>
// //                 {showInfoBox && (
// //                     <Box
// //                         sx={{
// //                             backgroundColor: "#FFF7E6",
// //                             padding: "8px 16px",
// //                             borderRadius: "8px 8px 0 0",
// //                             display: "flex",
// //                             alignItems: "center",
// //                             gap: 1,
// //                             width: "100%",
// //                             marginBottom: "16px",
// //                         }}
// //                     >
// //                         <Box>
// //                             <Typography variant="body2" sx={{ color: "#5F5F5F" }}>
// //                                 <InfoOutlinedIcon fontSize="small" sx={{ color: "#9E9E9E", verticalAlign: "top" }} /> Profile Update
// //                             </Typography>
// //                             <Typography sx={{ fontSize: "14px", color: "#494A4B", width: "100%" }}>
// //                                 Your profile is paused. You cannot access any modules or perform any activities. Admin will notify you once your profile is reactivated.
// //                             </Typography>
// //                         </Box>
// //                     </Box>
// //                 )}

// //                 <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3, mt: 1 }}>
// //                     <Avatar sx={{ fontSize: "33px", bgcolor: "#fff", color: "#B90022", border: "1px solid #B90022", width: 60, height: 60, fontWeight: "600" }}>
// //                         A
// //                     </Avatar>
// //                     <Box>
// //                         <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "600" }}>Amit Singh</Typography>
// //                         <Typography variant="body2" color="text.secondary" sx={{ fontSize: "16px", paddingTop: "2px" }}>
// //                             amit.singh@company.com
// //                         </Typography>
// //                     </Box>
// //                 </Box>
// //             </Box>
// //         </Box > <Box sx={{ p: 4 }}>
// //                 <Paper elevation={1} sx={{ p: 3, mb: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
// //                     <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
// //                         PERSONAL INFORMATION
// //                     </Typography>

// //                     <IconButton
// //                         size="small"
// //                         onClick={() => setOpenDialog(true)}
// //                         sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f", display: "flex", alignItems: "center" }}
// //                     >
// //                         <EditIcon fontSize="small" />
// //                         <Typography variant="body2" sx={{ ml: 0.5 }}>
// //                             Request to Edit
// //                         </Typography>
// //                     </IconButton>
// //                     <EditRequest
// //                         open={openDialog}
// //                         onClose={() => setOpenDialog(false)}
// //                         onSubmit={handleSubmit}
// //                         info={info}
// //                         requestText={requestText}
// //                         setRequestText={setRequestText}
// //                     />
// //                     <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 2 }}>
// //                         {[
// //                             { label: "First Name", value: "Amit" },
// //                             { label: "Last Name", value: "Singh" },
// //                             { label: "Mobile Number", value: "9492037489" },
// //                             { label: "Company Email ID", value: "amit@company.com" },
// //                             { label: "Team", value: "TFR" },
// //                             { label: "Module Access", value: "Dashboard, Report" },
// //                             { label: "Module Owner", value: "Misha Mehta" },
// //                         ].map((item) => (
// //                             <Box key={item.label} sx={{ width: "50%", mb: 1 }}>
// //                                 <Typography variant="body2" color="text.secondary">
// //                                     {item.label}
// //                                 </Typography>
// //                                 <Typography variant="body1" fontWeight={600} sx={{ fontSize: "16px" }}>
// //                                     {item.value}
// //                                 </Typography>
// //                             </Box>
// //                         ))}
// //                     </Box>
// //                 </Paper>

// //                 {/* Login Info Card */}
// //                 <Paper elevation={1} sx={{ p: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
// //                     <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
// //                         LOGIN ID & PASSWORD
// //                     </Typography>

// //                     <IconButton
// //                         size="small"
// //                         sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f" }}
// //                     >
// //                         <EditIcon fontSize="small" />
// //                         <Typography variant="body2" sx={{ ml: 0.5 }}>
// //                             Change Password
// //                         </Typography>
// //                     </IconButton>

// //                     <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
// //                         <Box sx={{ width: "44%" }}>
// //                             <Typography variant="body2" color="text.secondary">
// //                                 Team
// //                             </Typography>
// //                             <Typography variant="body1" fontWeight={600}>
// //                                 amit@company.commmmmmmmmmmmmmmmmmmmmmmmmmmm
// //                             </Typography>
// //                         </Box>
// //                         <Box>
// //                             <Typography variant="body2" color="text.secondary">
// //                                 Password
// //                             </Typography>
// //                             <Typography variant="body1" fontWeight={600}>
// //                                 ••••••••
// //                             </Typography>
// //                         </Box>
// //                     </Box>
// //                 </Paper>
// //             </Box></>

// //     );
// // };

// // // export default ProfileSetting;
// // import React, { useState, useEffect } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Avatar,
// //   Paper,
// //   IconButton,
// //   Divider,
// // } from "@mui/material";
// // import EditIcon from "@mui/icons-material/Edit";
// // import EditRequest from "./EditRequest";
// // import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// // import { profiledata } from "./api"; // Adjust path to your api.ts
// // import { getToken } from "../../utils/utils";

// // interface ProfileInfo {
// //   firstName: string;
// //   lastName: string;
// //   mobile: string;
// //   email: string;
// //   team: string;
// //   access: string;
// //   owner: string;
// // }

// // interface TeamMember {
// //   id: number;
// //   first_name: string;
// //   last_name: string;
// //   email: string;
// //   phone: string;
// //   company_email_id: string;
// //   teams: { id: number; team_name: string }[];
// //   modules: { id: number; module_name: string }[];
// //   module_owner_data: { id: number; first_name: string }[];
// // }

// // const ProfileSetting = () => {
// //   const [openDialog, setOpenDialog] = useState(false);
// //   const [requestText, setRequestText] = useState("");
// //   const [showInfoBox, setShowInfoBox] = useState(false);
// //   const [info, setInfo] = useState<ProfileInfo>({
// //     firstName: "",
// //     lastName: "",
// //     mobile: "",
// //     email: "",
// //     team: "",
// //     access: "",
// //     owner: "",
// //   });
// //   const [adminId, setAdminId] = useState<string>("");
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState<string | null>(null);
// //   const token = getToken();

// //   useEffect(() => {
// //     const fetchProfileData = async () => {
// //       setLoading(true);
// //       setError(null);
// //       try {
// //         const response = await profiledata(token);
// //         const member: TeamMember = response.data.data[0]; // Take first item
// //         setAdminId(member.id.toString());
// //         setInfo({
// //           firstName: member.first_name,
// //           lastName: member.last_name,
// //           mobile: member.phone,
// //           email: member.company_email_id,
// //           team: member.teams.map((team) => team.team_name).join(", "),
// //           access: member.modules.map((module) => module.module_name).join(", "),
// //           owner: member.module_owner_data
// //             .map((owner) => owner.first_name)
// //             .join(", "),
// //         });
// //       } catch (err) {
// //         console.error("Error fetching profile data:", err);
// //         setError("Failed to load profile data.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     if (token) {
// //       fetchProfileData();
// //     } else {
// //       setError("Authentication token missing.");
// //       setLoading(false);
// //     }
// //   }, [token]);

// //   const handleSubmit = (request: string) => {
// //     console.log("Request submitted:", request, "for adminId:", adminId);
// //     setOpenDialog(false);
// //     setShowInfoBox(true);
// //     // getrequestdata API call is handled in EditRequest
// //   };

// //   if (loading) {
// //     return <Typography>Loading profile...</Typography>;
// //   }

// //   if (error) {
// //     return <Typography color="error">{error}</Typography>;
// //   }

// //   return (
// //     <>
// //       <Box sx={{ background: "#fff", borderBottom: "1px solid #7f7d7d70 !important" }}>
// //         <Box sx={{ p: 4 }}>
// //           <Typography variant="body2" sx={{ mb: 1 }}>
// //             <span style={{ color: "#777" }}>Profile /</span>{" "}
// //             <span style={{ color: "#8E020F", fontWeight: 500 }}>Profile Setting</span>
// //           </Typography>
// //           <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
// //             Profile Setting
// //           </Typography>
// //           {showInfoBox && (
// //             <Box
// //               sx={{
// //                 backgroundColor: "#FFF7E6",
// //                 padding: "8px 16px",
// //                 borderRadius: "8px 8px 0 0",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 1,
// //                 width: "100%",
// //                 marginBottom: "16px",
// //               }}
// //             >
// //               <Box>
// //                 <Typography variant="body2" sx={{ color: "#5F5F5F" }}>
// //                   <InfoOutlinedIcon fontSize="small" sx={{ color: "#9E9E9E", verticalAlign: "top" }} /> Profile Update
// //                 </Typography>
// //                 <Typography sx={{ fontSize: "14px", color: "#494A4B", width: "100%" }}>
// //                   Your profile is paused. You cannot access any modules or perform any activities. Admin will notify you once your profile is reactivated.
// //                 </Typography>
// //               </Box>
// //             </Box>
// //           )}

// //           <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3, mt: 1 }}>
// //             <Avatar
// //               sx={{
// //                 fontSize: "33px",
// //                 bgcolor: "#fff",
// //                 color: "#B90022",
// //                 border: "1px solid #B90022",
// //                 width: 60,
// //                 height: 60,
// //                 fontWeight: "600",
// //               }}
// //             >
// //               {info.firstName.charAt(0).toUpperCase()}
// //             </Avatar>
// //             <Box>
// //               <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "600" }}>
// //                 {info.firstName} {info.lastName}
// //               </Typography>
// //               <Typography variant="body2" color="text.secondary" sx={{ fontSize: "16px", paddingTop: "2px" }}>
// //                 {info.email}
// //               </Typography>
// //             </Box>
// //           </Box>
// //         </Box>
// //       </Box>
// //       <Box sx={{ p: 4 }}>
// //         <Paper elevation={1} sx={{ p: 3, mb: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
// //           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
// //             PERSONAL INFORMATION
// //           </Typography>

// //           <IconButton
// //             size="small"
// //             onClick={() => setOpenDialog(true)}
// //             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f", display: "flex", alignItems: "center" }}
// //           >
// //             <EditIcon fontSize="small" />
// //             <Typography variant="body2" sx={{ ml: 0.5 }}>
// //               Request to Edit
// //             </Typography>
// //           </IconButton>
// //           <EditRequest
// //                       open={openDialog}
// //                       onClose={() => setOpenDialog(false)}
// //                       onSubmit={handleSubmit}
// //                       // adminId={adminId}
// //                       info={info}
// //                       requestText={requestText}
// //                       setRequestText={setRequestText} adminId={""}          />
// //           <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 2 }}>
// //             {[
// //               { label: "First Name", value: info.firstName },
// //               { label: "Last Name", value: info.lastName },
// //               { label: "Mobile Number", value: info.mobile },
// //               { label: "Company Email ID", value: info.email },
// //               { label: "Team", value: info.team },
// //               { label: "Module Access", value: info.access },
// //               { label: "Module Owner", value: info.owner },
// //             ].map((item) => (
// //               <Box key={item.label} sx={{ width: "50%", mb: 1 }}>
// //                 <Typography variant="body2" color="text.secondary">
// //                   {item.label}
// //                 </Typography>
// //                 <Typography variant="body1" fontWeight={600} sx={{ fontSize: "16px" }}>
// //                   {item.value || "N/A"}
// //                 </Typography>
// //               </Box>
// //             ))}
// //           </Box>
// //         </Paper>

// //         {/* Login Info Card */}
// //         <Paper elevation={1} sx={{ p: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
// //           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
// //             LOGIN ID & PASSWORD
// //           </Typography>

// //           <IconButton
// //             size="small"
// //             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f" }}
// //           >
// //             <EditIcon fontSize="small" />
// //             <Typography variant="body2" sx={{ ml: 0.5 }}>
// //               Change Password
// //             </Typography>
// //           </IconButton>

// //           <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
// //             <Box sx={{ width: "44%" }}>
// //               <Typography variant="body2" color="text.secondary">
// //                 Team
// //               </Typography>
// //               <Typography variant="body1" fontWeight={600}>
// //                 {info.email}
// //               </Typography>
// //             </Box>
// //             <Box>
// //               <Typography variant="body2" color="text.secondary">
// //                 Password
// //               </Typography>
// //               <Typography variant="body1" fontWeight={600}>
                
// //               </Typography>
// //             </Box>
// //           </Box>
// //         </Paper>
// //       </Box>
// //     </>
// //   );
// // };

// // export default ProfileSetting;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import EditRequest from "./EditRequest";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import { profiledata } from "./api"; // Adjust path to your api.ts
// import { getToken } from "../../utils/utils";

// interface ProfileInfo {
//   firstName: string;
//   lastName: string;
//   mobile: string;
//   email: string;
//   team: string;
//   access: string;
//   owner: string;
// }

// interface TeamMember {
//   id: number;
//   first_name: string;
//   last_name: string;
//   email: string;
//   phone: string;
//   company_email_id: string;
//   teams: { id: number; team_name: string }[];
//   modules: { id: number; module_name: string }[];
//   module_owner_data: { id: number; first_name: string }[];
// }

// const ProfileSetting = () => {
//   const [openDialog, setOpenDialog] = useState(false);
//   const [requestText, setRequestText] = useState("");
//   const [showInfoBox, setShowInfoBox] = useState(false);
//   const [info, setInfo] = useState<ProfileInfo>({
//     firstName: "",
//     lastName: "",
//     mobile: "",
//     email: "",
//     team: "",
//     access: "",
//     owner: "",
//   });
//   const [adminId, setAdminId] = useState<string>("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const token = getToken();

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await profiledata(token);
//         const member: TeamMember = response.data.data[0]; // Take first item
//         setAdminId(member.id.toString());
//         setInfo({
//           firstName: member.first_name,
//           lastName: member.last_name,
//           mobile: member.phone,
//           email: member.company_email_id,
//           team: member.teams.map((team) => team.team_name).join(", "),
//           access: member.modules.map((module) => module.module_name).join(", "),
//           owner: member.module_owner_data
//             .map((owner) => owner.first_name)
//             .join(", "),
//         });
//       } catch (err) {
//         console.error("Error fetching profile data:", err);
//         setError("Failed to load profile data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (token) {
//       fetchProfileData();
//     } else {
//       setError("Authentication token missing.");
//       setLoading(false);
//     }
//   }, [token]);

//   const handleSubmit = (request: string) => {
//     console.log("Request submitted:", request, "for adminId:", adminId);
//     setOpenDialog(false);
//     setShowInfoBox(true);
//     // getrequestdata API call is handled in EditRequest
//   };

//   if (loading) {
//     return <Typography>Loading profile...</Typography>;
//   }

//   if (error) {
//     return <Typography color="error">{error}</Typography>;
//   }

//   return (
//     <>
//       <Box sx={{ background: "#fff", borderBottom: "1px solid #7f7d7d70 !important" }}>
//         <Box sx={{ p: 4 }}>
//           <Typography variant="body2" sx={{ mb: 1 }}>
//             <span style={{ color: "#777" }}>Profile /</span>{" "}
//             <span style={{ color: "#8E020F", fontWeight: 500 }}>Profile Setting</span>
//           </Typography>
//           <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
//             Profile Setting
//           </Typography>
//           {showInfoBox && (
//             <Box
//               sx={{
//                 backgroundColor: "#FFF7E6",
//                 padding: "8px 16px",
//                 borderRadius: "8px 8px 0 0",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 width: "100%",
//                 marginBottom: "16px",
//               }}
//             >
//               <Box>
//                 <Typography variant="body2" sx={{ color: "#5F5F5F" }}>
//                   <InfoOutlinedIcon fontSize="small" sx={{ color: "#9E9E9E", verticalAlign: "top" }} /> Profile Update
//                 </Typography>
//                 <Typography sx={{ fontSize: "14px", color: "#494A4B", width: "100%" }}>
//                   Your profile is paused. You cannot access any modules or perform any activities. Admin will notify you once your profile is reactivated.
//                 </Typography>
//               </Box>
//             </Box>
//           )}

//           <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3, mt: 1 }}>
//             <Avatar
//               sx={{
//                 fontSize: "33px",
//                 bgcolor: "#fff",
//                 color: "#B90022",
//                 border: "1px solid #B90022",
//                 width: 60,
//                 height: 60,
//                 fontWeight: "600",
//               }}
//             >
//               {info.firstName.charAt(0).toUpperCase()}
//             </Avatar>
//             <Box>
//               <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "600" }}>
//                 {info.firstName} {info.lastName}
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ fontSize: "16px", paddingTop: "2px" }}>
//                 {info.email}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//       <Box sx={{ p: 4 }}>
//         <Paper elevation={1} sx={{ p: 3, mb: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
//           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
//             PERSONAL INFORMATION
//           </Typography>

//           <IconButton
//             size="small"
//             onClick={() => setOpenDialog(true)}
//             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f", display: "flex", alignItems: "center" }}
//           >
//             <EditIcon fontSize="small" />
//             <Typography variant="body2" sx={{ ml: 0.5 }}>
//               Request to Edit
//             </Typography>
//           </IconButton>
//           <EditRequest
//             open={openDialog}
//             onClose={() => setOpenDialog(false)}
//             onSubmit={handleSubmit}
//             adminId="1" // Pass adminId from state
//             info={info}
//             requestText={requestText}
//             setRequestText={setRequestText}
//           />
//           <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 2 }}>
//             {[
//               { label: "First Name", value: info.firstName },
//               { label: "Last Name", value: info.lastName },
//               { label: "Mobile Number", value: info.mobile },
//               { label: "Company Email ID", value: info.email },
//               { label: "Team", value: info.team },
//               { label: "Module Access", value: info.access },
//               { label: "Module Owner", value: info.owner },
//             ].map((item) => (
//               <Box key={item.label} sx={{ width: "50%", mb: 1 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   {item.label}
//                 </Typography>
//                 <Typography variant="body1" fontWeight={600} sx={{ fontSize: "16px" }}>
//                   {item.value || "N/A"}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>
//         </Paper>

//         {/* Login Info Card */}
//         <Paper elevation={1} sx={{ p: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
//           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
//             LOGIN ID & PASSWORD
//           </Typography>

//           <IconButton
//             size="small"
//             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f" }}
//           >
//             <EditIcon fontSize="small" />
//             <Typography variant="body2" sx={{ ml: 0.5 }}>
//               Change Password
//             </Typography>
//           </IconButton>

//           <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
//             <Box sx={{ width: "44%" }}>
//               <Typography variant="body2" color="text.secondary">
//                 Team
//               </Typography>
//               <Typography variant="body1" fontWeight={600}>
//                 {info.email}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography variant="body2" color="text.secondary">
//                 Password
//               </Typography>
//               <Typography variant="body1" fontWeight={600}>
//                 ••••••••
//               </Typography>
//             </Box>
//           </Box>
//         </Paper>
//       </Box>
//     </>
//   );
// };

// export default ProfileSetting;




// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import EditRequest from "./EditRequest";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import { profiledata } from "./api"; // Adjust path to your api.ts
// import { getToken } from "../../utils/utils";
// import { Link } from "react-router-dom";

// interface ProfileInfo {
//   firstName: string;
//   lastName: string;
//   mobile: string;
//   email: string;
//   team: string;
//   access: string;
//   owner: string;
// }

// interface TeamMember {
//   id: number;
//   first_name: string;
//   last_name: string;
//   email: string;
//   phone: string;
//   company_email_id: string;
//   teams: { id: number; team_name: string }[];
//   modules: { id: number; module_name: string }[];
//   module_owner_data: { id: number; first_name: string }[];
// }

// const ProfileSetting = () => {
//   const [openDialog, setOpenDialog] = useState(false);
//   const [requestText, setRequestText] = useState("");
//   const [showInfoBox, setShowInfoBox] = useState(false);
//   const [info, setInfo] = useState<ProfileInfo>({
//     firstName: "",
//     lastName: "",
//     mobile: "",
//     email: "",
//     team: "",
//     access: "",
//     owner: "",
//   });
//   const [adminId, setAdminId] = useState<string>("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const token = getToken();

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await profiledata(token);
//         const member: TeamMember = response.data.data[0]; // Take first item
//         setAdminId(member.id.toString());
//         setInfo({
//           firstName: member.first_name,
//           lastName: member.last_name,
//           mobile: member.phone,
//           email: member.company_email_id,
//           team: member.teams.map((team) => team.team_name).join(", "),
//           access: member.modules.map((module) => module.module_name).join(", "),
//           owner: member.module_owner_data
//             .map((owner) => owner.first_name)
//             .join(", "),
//         });
//       } catch (err) {
//         console.error("Error fetching profile data:", err);
//         setError("Failed to load profile data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (token) {
//       fetchProfileData();
//     } else {
//       setError("Authentication token missing.");
//       setLoading(false);
//     }
//   }, [token]);

//   const handleSubmit = (request: string) => {
//     console.log("Request submitted:", request, "for adminId:", adminId);
//     setOpenDialog(false);
//     setShowInfoBox(true);
//     // getrequestdata API call is handled in EditRequest
//   };

//   if (loading) {
//     return <Typography>Loading profile...</Typography>;
//   }

//   if (error) {
//     return <Typography color="error">{error}</Typography>;
//   }

//   return (
//     <>
//       <Box sx={{ background: "#fff", borderBottom: "1px solid #7f7d7d70 !important" }}>
//         <Box sx={{ p: 4 }}>
//           <Typography variant="body2" sx={{ mb: 1 }}>
//             <span style={{ color: "#777" }}>Profile /</span>{" "}
//             <span style={{ color: "#8E020F", fontWeight: 500 }}>Profile Setting</span>
//           </Typography>
//           <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
            
//             Profile Setting
//           </Typography>
//           {showInfoBox && (
//             <Box
//               sx={{
//                 backgroundColor: "#FFF7E6",
//                 padding: "8px 16px",
//                 borderRadius: "8px 8px 0 0",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 width: "100%",
//                 marginBottom: "16px",
//               }}
//             >
//               <Box>
//                 <Typography variant="body2" sx={{ color: "#5F5F5F" }}>
//                   <InfoOutlinedIcon fontSize="small" sx={{ color: "#9E9E9E", verticalAlign: "top" }} /> Edit request
//                 </Typography>
//                 <Typography sx={{ fontSize: "14px", color: "#494A4B", width: "100%" }}>
//                   {/* Your profile is paused. You cannot access any modules or perform any activities. Admin will notify you once your profile is reactivated. */}
//                   You have made an edit request for changing               

//                 </Typography>
//               </Box>
//             </Box>
//           )}

//           <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3, mt: 1 }}>
//             <Avatar
//               sx={{
//                 fontSize: "33px",
//                 bgcolor: "#fff",
//                 color: "#B90022",
//                 border: "1px solid #B90022",
//                 width: 60,
//                 height: 60,
//                 fontWeight: "600",
//               }}
//             >
//               {info.firstName.charAt(0).toUpperCase()}
//             </Avatar>
//             <Box>
//               <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "600" }}>
//                 {info.firstName} {info.lastName}
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ fontSize: "16px", paddingTop: "2px" }}>
//                 {info.email}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//       <Box sx={{ p: 4 }}>
//         <Paper elevation={1} sx={{ p: 3, mb: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
//           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
//             PERSONAL INFORMATION
//           </Typography>

//           <IconButton
//             size="small"
//             onClick={() => setOpenDialog(true)}
//             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f", display: "flex", alignItems: "center" }}
//           >
//             <EditIcon fontSize="small" />
//             <Typography variant="body2" sx={{ ml: 0.5 }}>
//               Request to Edit
//             </Typography>
//           </IconButton>
//           <EditRequest
//             open={openDialog}
//             onClose={() => setOpenDialog(false)}
//             onSubmit={handleSubmit}
//             adminId={adminId}// Pass adminId from state
//             info={info}
//             requestText={requestText}
//             setRequestText={setRequestText}
//           />
//           <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 2 }}>
//             {[
//               { label: "First Name", value: info.firstName },
//               { label: "Last Name", value: info.lastName },
//               { label: "Mobile Number", value: info.mobile },
//               { label: "Company Email ID", value: info.email },
//               { label: "Team", value: info.team },
//               { label: "Module Access", value: info.access },
//               { label: "Module Owner", value: info.owner },
//             ].map((item) => (
//               <Box key={item.label} sx={{ width: "50%", mb: 1 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   {item.label}
//                 </Typography>
//                 <Typography variant="body1" fontWeight={600} sx={{ fontSize: "16px" }}>
//                   {item.value || "N/A"}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>
//         </Paper>

//         {/* Login Info Card */}
//         <Paper elevation={1} sx={{ p: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
//           <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
//             LOGIN ID & PASSWORD
//           </Typography>

//           <IconButton
//             size="small"
//             sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f" }}
//           >
//             <EditIcon fontSize="small" />
//             <Typography variant="body2" sx={{ ml: 0.5 }}>
//               Change Password
//             </Typography>
//           </IconButton>

//           <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
//             <Box sx={{ width: "44%" }}>
//               <Typography variant="body2" color="text.secondary">
//                 Team
//               </Typography>
//               <Typography variant="body1" fontWeight={600}>
//                 {info.email}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography variant="body2" color="text.secondary">
//                 Password
//               </Typography>
//               <Typography variant="body1" fontWeight={600}>
//                 ••••••••
//               </Typography>
//             </Box>
//           </Box>
//         </Paper>
//       </Box>
//        <Box sx={{ position: "relative", width: "100%", marginTop: "50px" }}>
//                 <Box
//                     sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "space-between",
//                         background: "#fff",
//                         padding: "20px 32px",
//                         borderTop: "1px solid #d8d8d8",
//                         marginTop: "30px",
//                         position: "fixed",
//                         bottom: "0",
//                         width: "82%",
//                     }}
//                 >
//                     <Box>
//                         <Link to="#" style={{ textDecoration: 'none' }}>
//                             <Typography sx={{ color: "#C8172F", fontSize: "14px", cursor: 'pointer' }}>
//                                 ← Back
//                             </Typography>
//                         </Link>
//                     </Box>

//                 </Box >
//             </Box >
//     </>
//   );
// };

// export default ProfileSetting;
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Paper,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditRequest from "./EditRequest";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { profiledata } from "./api"; // Adjust path to your api.ts
import { decodeJWT, getToken } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import PauseAccountPopup from "../TeamMembers/PauseAccountPopup";

interface ProfileInfo {
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  company_email_id:string,
  team: string;
  access: string;
  owner: string;
}

interface TeamMember {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company_email_id: string;
  teams: { id: number; team_name: string }[];
  modules: { id: number; module_name: string }[];
  module_owner_data: { id: number; first_name: string }[];
  finalmoduleownernames:string
}

const ProfileSetting = () => {
  const [openDialog, setOpenDialog] = useState(false);
    const navigate = useNavigate();
  const [requestText, setRequestText] = useState("");
  const [submittedRequestText, setSubmittedRequestText] = useState(""); // New state for submitted request
  const [showInfoBox, setShowInfoBox] = useState(false);
     const [openPausePopup, setOpenPausePopup] = useState(true);
    const handleClosePopup = () => {
    setOpenPausePopup(false); // close popup
  };
  const [info, setInfo] = useState<ProfileInfo>({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    company_email_id:"",
    team: "",
    access: "",
    owner: "",
  });
  const [adminId, setAdminId] = useState<string>("");
  
    const [emailid, setemailid] = useState<string>("ssss");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const token = getToken();
  console.log('tokentokentokentokentokentokentokentoken',token)
 const decodedToken = decodeJWT(token);
      console.log(decodedToken, "Decoded token");

      const userRole = decodedToken?.user_role_name?.toLowerCase();
      const datat = decodedToken?.record_status?.toLowerCase();
  
      console.log(datat, "datatdatatdatatdatatdatat")
  useEffect(() => {
    const fetchProfileData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await profiledata({id:decodedToken.id|| ''},token);
        const member: TeamMember = response.data.data[0]; // Take first item
        setAdminId(member.id.toString());
        setemailid(member.email )
        setInfo({
          firstName: member.first_name,
          lastName: member.last_name,
          mobile: member.phone,
          email: member.email,
          company_email_id:member.company_email_id,
          team: member.teams.map((team) => team.team_name).join(", "),
          access: member.modules.map((module) => module.module_name).join(", "),
          owner: member.finalmoduleownernames,
        });
      } catch (err) {
        console.error("Error fetching profile data:", err);
        setError("Failed to load profile data.");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchProfileData();
    } else {
      setError("Authentication token missing.");
      setLoading(false);
    }
  }, [token]);

  const handleSubmit = (request: string) => {
    console.log("Request submitted:", request, "for adminId:", adminId);
    setSubmittedRequestText(request); // Store the submitted request text
    setRequestText(""); // Reset the request text for the dialog
    setOpenDialog(false);
    setShowInfoBox(true);
  };

  if (loading) {
    return <Typography>Loading profile...</Typography>;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }
console.log(emailid, "emailidemailidemailid")


  const handleClick = () => {
    navigate(`/change-password`);
  };

  return (
    <>
      <Box sx={{ background: "#fff", borderBottom: "1px solid #7f7d7d70 !important" }}>
        <Box sx={{ p: 4 }}>

          <Typography variant="body2" sx={{ mb: 1 }}>
            <span style={{ color: "#777" }}>Profile /</span>{" "}
            <span style={{ color: "#8E020F", fontWeight: 500 }}>Profile Setting</span>
          </Typography>
          <Typography variant="h5" fontWeight="600" sx={{ mb: 4 }}>
            Profile Setting
          </Typography>

          {showInfoBox && (
            <Box
              sx={{
                backgroundColor: "#FFF7E6",
                padding: "8px 16px",
                borderRadius: "8px 8px 0 0",
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
                marginBottom: "16px",
              }}
            >
              <Box>
                <Typography variant="body2" sx={{ color: "#5F5F5F" }}>
                  <InfoOutlinedIcon fontSize="small" sx={{ color: "#9E9E9E", verticalAlign: "top" }} /> Edit request
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#494A4B", width: "100%" }}>
                  You have made an edit request for changing: {submittedRequestText || "your profile details"}.
                </Typography>
              </Box>
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3, mt: 1 }}>
            <Avatar
              sx={{
                fontSize: "33px",
                bgcolor: "#fff",
                color: "#B90022",
                border: "1px solid #B90022",
                width: 60,
                height: 60,
                fontWeight: "600",
              }}
            >
              {info.firstName.charAt(0).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "600" }}>
                {info.firstName} {info.lastName}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: "16px", paddingTop: "2px" }}>
                {info.email}
              </Typography>
            </Box>
          {userRole === "team member" && datat === "paused" && (
  <PauseAccountPopup open={openPausePopup} handleClose={handleClosePopup} />
)}


          </Box>
        </Box>
      </Box>
      <Box sx={{ p: 4 }}>
        <Paper elevation={1} sx={{ p: 3, mb: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
          <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
            PERSONAL INFORMATION
          </Typography>

          <IconButton
            size="small"
            onClick={() => setOpenDialog(true)}
            sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f", display: "flex", alignItems: "center" }}
          >
            <EditIcon fontSize="small" />
            <Typography variant="body2" sx={{ ml: 0.5 }}>
              Request to Edit
            </Typography>
          </IconButton>
          <EditRequest
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onSubmit={handleSubmit}
            adminId={adminId}
            info={info}
            requestText={requestText}
            setRequestText={setRequestText}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 2 }}>
            {[
              { label: "First Name", value: info.firstName },
              { label: "Last Name", value: info.lastName },
              { label: "Mobile Number", value: info.mobile },
              { label: "Company Email ID", value: info.company_email_id },
              { label: "Team", value: info.team },
              { label: "Module Access", value: info.access },
              { label: "Module Owner", value: info.owner },
            ].map((item) => (
              <Box key={item.label} sx={{ width: "50%", mb: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  {item.label}
                </Typography>
                <Typography variant="body1" fontWeight={600} sx={{ fontSize: "16px" }}>
                  {item.value || "N/A"}
                </Typography>
              </Box>
            ))}
          </Box>
        </Paper>

        <Paper elevation={1} sx={{ p: 3, position: "relative", boxShadow: "none", border: "1px solid #7f7d7d70 !important" }}>
          <Typography variant="subtitle1" fontWeight="400" sx={{ color: "#7D7E7F" }} gutterBottom>
            LOGIN ID & PASSWORD
          </Typography>

          <IconButton
            size="small"
            sx={{ position: "absolute", top: 16, right: 16, color: "#d32f2f" }}
          >
            <EditIcon fontSize="small" />
<Typography
      variant="body2"
      sx={{ ml: 0.5, cursor: 'pointer', color: 'inherit', textDecoration: 'underline' }}
      onClick={handleClick}
    >
      Change Password
    </Typography>
          </IconButton>

          <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
            <Box sx={{ width: "44%" }}>
              <Typography variant="body2" color="text.secondary">
                Team
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {info.email}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Password
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                ••••••••
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
      <Box sx={{ position: "relative", width: "100%", marginTop: "50px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            padding: "20px 32px",
            borderTop: "1px solid #d8d8d8",
            marginTop: "30px",
            position: "fixed",
            bottom: "0",
            width: "82%",
          }}
        >
          <Box>
            <Link to="#" style={{ textDecoration: "none" }}>
              <Typography sx={{ color: "#C8172F", fontSize: "14px", cursor: "pointer" }}>
                ← Back
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProfileSetting;